// extracted by mini-css-extract-plugin
export default {"root":"RotateMobileMessage_root__ncQRV","content":"RotateMobileMessage_content__vXSAO","device":"RotateMobileMessage_device__58sVy"};